var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 66,
  height: 66,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#btc_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#774F00",
  d: "M32.96 60.159c14.978 0 27.12-12.142 27.12-27.12 0-14.977-12.142-27.119-27.12-27.119-14.977 0-27.12 12.142-27.12 27.12 0 14.977 12.143 27.119 27.12 27.119"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C98600",
  d: "M57.934 14.48h-12.47v9.458h12.47z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C98600",
  fillRule: "evenodd",
  d: "M7.986 23.938H28.23v34.448h9.458V23.938h.015V14.48H7.986z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C98600",
  d: "M32.96 7.863c13.885 0 25.18 11.295 25.18 25.179S46.844 58.22 32.96 58.22 7.781 46.926 7.781 33.04c0-13.883 11.295-25.178 25.18-25.178m0-7.784C14.758.08 0 14.837 0 33.04S14.758 66 32.96 66s32.96-14.758 32.96-32.96S51.164.08 32.96.08"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42.805 26.895c-.332-3.5-3.35-4.68-7.165-5.018l.006-4.856-2.954-.004-.007 4.728c-.776 0-1.57.013-2.36.028l.006-4.758-2.954-.005-.01 4.854q-.96.02-1.88.022v-.016l-4.077-.006-.004 3.157s2.182-.038 2.145 0c1.197 0 1.586.697 1.698 1.298l-.02 13.3c-.052.377-.275.978-1.11.978.037.033-2.148-.005-2.148-.005l-.592 3.529 3.846.007c.715 0 1.419.015 2.112.02l-.007 4.91 2.953.004.006-4.857q1.213.026 2.361.026l-.009 4.836 2.955.004.009-4.902c4.97-.277 8.448-1.524 8.885-6.188.355-3.756-1.41-5.436-4.23-6.116 1.714-.87 2.787-2.405 2.54-4.968zm-4.149 10.494c-.004 3.67-6.285 3.243-8.29 3.243l.011-6.506c2.005.005 8.286-.563 8.279 3.265zm-1.362-9.18c-.006 3.337-5.245 2.94-6.914 2.939l.008-5.9c1.668.001 6.91-.522 6.906 2.96"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "btc_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h66v66H0z"
})))));
export default SvgBtc;